/* unplugin-vue-components disabled */import script from "./TravelPriceOperate.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelPriceOperate.vue?vue&type=script&setup=true&lang=js"

import "./TravelPriceOperate.vue?vue&type=style&index=0&id=00cd1071&lang=scss"

const __exports__ = script;

export default __exports__